<template>
    <button
        type="button"
        class="slider-button-next rounded-sm absolute right-0 top-1/2 z-10 -translate-y-1/2 cursor-pointer bg-green-300 p-3 transition-opacity duration-200 hover:bg-green-500 disabled:opacity-0 lg:right-10">
        <ArrowRightIcon class="mx-auto !w-4 stroke-[2.5px] text-black lg:!w-5" />
    </button>
</template>
<script setup lang="ts">
    import { ArrowRightIcon } from '@heroicons/vue/24/outline';
</script>
